import getQueues from '../../api/getQueues';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import setQueueStatus from './setQueueStatus';
import getQueue from '../../lib/getQueue';
import log from '../../lib/log';
import { serviceState } from '../../lib/state';

async function handleQueueSessionLeft(event: Telecom.QueueSessionLeftEvent) {
  const queue = getQueue(event.queueId);

  log('rtcs:queue:session_left:' + queue?.name, event);

  if (!queue) {
    serviceState.queues = await getQueues();
    return;
  }

  setQueueStatus(queue, event);

  queue.sessions = [
    ...queue.sessions.filter((s) => s.id !== event.conversationId),
  ];
}

export default handleQueueSessionLeft;
